import React from "react";

import ContractPreviewContent from "../components/trips/preview-contract-content";

const ContractPreview = () => {
  return <ContractPreviewContent />;
};

export default ContractPreview;
